export default "__VITE_ASSET__88b72511__"